import config from 'config/seo';

import { Container, Slogan } from './styles';

interface ILogo {
  version?: 'default' | 'footer';
  withSlogan?: boolean;
}
const Logo: React.FC<ILogo> = ({ version = 'default', withSlogan }) => (
  <div className={`logo logo-${version}`}>
    <Container
      src={`/images/logo/${version}.png`}
      srcWebp={`/images/logo/webp/${version}.webp`}
      alt={config.title}
    />
    {withSlogan && (
      <Slogan>
        Centro de Experiências <br /> Cientificas e Digitais
      </Slogan>
    )}
  </div>
);

export default Logo;
